import script from "./mailbox.vue?vue&type=script&setup=true&lang=js"
export * from "./mailbox.vue?vue&type=script&setup=true&lang=js"

import "./mailbox.vue?vue&type=style&index=0&id=767a40dc&lang=css"

const __exports__ = script;

export default __exports__